import { createSelector } from 'reselect';
import { RootState } from '../root-reducer';

export const contestSubmissionsSelector = createSelector(
    (state: RootState) => state.contest,
    contest => ({
        contestSubmissions: contest.contestSubmissions,
        loadingSubmissions: contest.loadingSubmissions,
        searchingSubmissions: contest.searchingSubmissions,
        submissionsError: contest.submissionsError,
        submissionsContest: contest.submissionsContest,
        availableFilters: contest.availableFilters,
    }),
);
